import { flattenDeep } from 'lodash';

import { fireworks, shoolPride } from './fireworks';

export const getVideosByGroup = (Book, groupIdx) =>
  Array.isArray(Book.readingGroupList) &&
  flattenDeep(
    flattenDeep(
      Book.readingGroupList
        .map((v) => v.groups[groupIdx].details)
        .map((v) => {
          if (v.length == 0) {
            return v;
          }
          const last = v.pop();
          if (last.bullets.length == 0) {
            v.push(last);
            return v;
          }
          const lastBullet = last.bullets.pop();
          lastBullet['endOfReading'] = true;
          last.bullets.push(lastBullet);
          v.push(last);
          return v;
        })
    ).map((v) => v.bullets)
  ).map((v, i, arr) => {
    return {
      bulletName: v.bulletName,
      bulletId: v.bulletId,
      videoId: v.videoId,
      speed1: v.vpath,
      speed1Dot3: v.vpath_1_3,
      speed1Dot5: v.vpath_1_5,
      speed2: v.vpath_2,
      isLatest: i === arr.length - 1,
      endOfReading: v.endOfReading ? true : false,
      collected: v.collected ? true : false,
    };
  });

export const playSound = function (src) {
  this.sound = document.createElement('audio');
  this.sound.src = src;
  this.sound.setAttribute('preload', 'auto');
  this.sound.setAttribute('controls', 'none');
  this.sound.style.display = 'none';
  document.body.appendChild(this.sound);
  this.play = function () {
    this.sound.play();
  };
  this.stop = function () {
    this.sound.pause();
  };
};

export const getLevelText = function (currentLevel) {
  let nextLevelText = '';
  switch (currentLevel) {
    case 0:
      nextLevelText = '未开始';
      break;
    case 3:
      nextLevelText = '熟悉';
      break;
    case 1:
      nextLevelText = '练习中';
      break;
    case 2:
      nextLevelText = '初步了解';
      break;
    case 4:
      nextLevelText = '精通';
      break;
    default:
      nextLevelText = '';
  }
  return nextLevelText;
};

export const getChallengeProps = (vm) => ({
  id: 'pz-unit-test',
  exerciseType: 12,
  title: `${vm.Book.bookName}-挑战`,
  visiable: vm.isShowChallenge,
  markable: true,
  onMark: vm.mark,
  notable: true,
  qable: true,
  onClose: vm.closeChallenge,
  QuestionList: vm.QuestionList,
  Question: vm.Question,
  isShowScantron: false,
  isShowStepper: true,
  onAnswer: vm.doAnswer,
  onGoTo: vm.goToQuestion,
  hasBefore: true,
  BeforeData: vm.BeforeChallengeData,
  onGetQuestions: vm.getChallengeData,
  hasAfter: true,
  AfterData: vm.AfterChallengeData,
  onGetAfterData: vm.getAfterChallengeData,
  isTakingExam: false,
  onSetQuestion: vm.setQuestion,
  key: 'unit-test',
});

export const getPracticeProps = (vm) => ({
  exerciseType: 11,
  title: vm.questionTitle,
  visiable: vm.isShowPractice,
  markable: true,
  onMark: vm.mark,
  notable: true,
  qable: true,
  onClose: vm.closePractice,
  QuestionList: vm.QuestionList,
  Question: vm.Question,
  isShowScantron: false,
  isShowStepper: true,
  onAnswer: vm.doAnswer,
  onGoTo: vm.goToQuestion,
  hasBefore: true,
  BeforeData: vm.BeforePracticeData,
  onGetQuestions: vm.getPracticeData,
  hasAfter: true,
  AfterData: vm.AfterPracticeData,
  onGetAfterData: vm.getAfterPracticeData,
  tips: vm.tips,
  isTakingExam: false,
  onSetQuestion: vm.setQuestion,
  key: 'practice',
});

export const mapStringToKatex = () => {
  const arr = document.querySelectorAll('.math-tex');
  for (let i = 0, len = arr.length; i < len; i++) {
    window.renderMathInElement(arr[i]);
  }
};

export const triggerShoolPride = () => {
  shoolPride();
  const mySound = new playSound('http://class.pzacademy.com/mp3/level-up.mp3');
  mySound.play();
};

export const triggerFireworks = () => {
  fireworks();
  const mySound = new playSound('http://class.pzacademy.com/mp3/progress_stats.mp3');
  mySound.play();
};

export const getCourseLevelText = (level) => {
  let text = '';
  switch (level) {
    case 0:
      text = '';
      break;
    case 1:
      text = '青铜';
      break;
    case 2:
      text = '白银';
      break;
    case 3:
      text = '黄金';
      break;
    default:
      text = '';
  }
  return text;
};

export const getDurationString = (second) => {
  let sec_num = parseInt(second, 10); // don't forget the second param
  let hours = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - hours * 3600) / 60);
  let seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  return (
    (hours == '00' ? '' : hours + '小时') + (minutes == '00' ? '' : minutes + '分') + seconds + '秒'
  );
};
